module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-wind@2x.png?71ab8d28c43b312c0fb12dfc5c525430";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-wind@2x.png
// module id = 1056
// module chunks = 1